import { patch } from '..';

const updateTicketMessage = (ticketId: string, message: string) => patch(
  `assets/tickets/${ticketId}`,
  { message },
);

export default updateTicketMessage;
